import { render, staticRenderFns } from "./GoodsAction.vue?vue&type=template&id=378fcb98&"
import script from "./GoodsAction.vue?vue&type=script&lang=js&"
export * from "./GoodsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports